/**
 * TS mirrors of the transfer DTOs exposed by dmp-configurator's TransferResource
 * (fr.traveljuice.dmp.configurator.transfer.dto.*). Hand-written because the generated
 * @tj/tj-dmp-lib-api client predates the /api/transfers endpoints.
 */

export const TRANSFERABLE_TYPES = [
    'table',
    'dataview',
    'campaign',
    'scenario',
    'newsletter',
    'landingpage',
    'templatehtml',
    'savequery'
] as const;

export type TransferableType = typeof TRANSFERABLE_TYPES[number];

export interface TransferObjectRef {
    type: string;
    code: string;
    name?: string;
}

export interface TransferObject {
    ref: TransferObjectRef;
    schemaVersion: number;
    payload: unknown;
    dependsOn: TransferObjectRef[];
}

export interface TransferManifest {
    transferId: string;
    formatVersion: number;
    exportedAt: string;
    sourceTenant: string;
    objects: TransferObject[];
}

export interface TransferTypeInfo {
    type: string;
    schemaVersion: number;
}

export interface ExportRequest {
    objects: TransferObjectRef[];
}

export type ConflictStrategy = 'OVERWRITE' | 'DUPLICATE' | 'IGNORE';

export interface ConflictOverride {
    ref: TransferObjectRef;
    strategy: ConflictStrategy;
}

export interface ImportRequest {
    manifest: TransferManifest;
    selection?: TransferObjectRef[];
    dryRun: boolean;
    conflictStrategy: ConflictStrategy;
    perRefStrategy?: ConflictOverride[];
}

export type Severity = 'WARNING' | 'ERROR';

export interface ValidationIssue {
    severity: Severity;
    ref: TransferObjectRef;
    code: string;
    message: string;
}

export type ImportStatus = 'CREATED' | 'UPDATED' | 'DUPLICATED' | 'IGNORED' | 'ERROR';

export interface ObjectImportResult {
    ref: TransferObjectRef;
    status: ImportStatus;
    issues: ValidationIssue[];
}

export type OverallStatus = 'SUCCESS' | 'PARTIAL' | 'FAILED';

export interface ImportReport {
    transferId: string;
    dryRun: boolean;
    sourceTenant: string;
    targetTenant: string;
    overallStatus: OverallStatus;
    results: ObjectImportResult[];
    warnings: ValidationIssue[];
}
